module.exports = __webpack_public_path__ + "img/t2-3.5c14d058.svg";